export default __webpack_public_path__ + "static/media/Imagen_testAB.10a7c59e.png";